import React from 'react';
import { useTheme } from '../../context/theme.context';

/**
 * Componente que genera el head
 *
 * @component
 * @returns {React.ReactElement}
 */
export default function Head() {
  const { mainImage, mainImageType } = useTheme();
  return (
    <header className="c-sii-header">
      {mainImage && (
        <h1>
          <img src={`${mainImageType},${mainImage}`} alt="logo" />
        </h1>
      )}
    </header>
  );
}

Head.propTypes = {};
